import { FC, PropsWithChildren } from "react";
import useI18n from "../../../hooks/useTranslations";
import ErrorText from "../ErrorText";
import styles from "./MapsContainer.module.css";

type MapsContainerProps = PropsWithChildren<{
  isLoading?: boolean;
  isDisabled?: boolean;
  error?: boolean;
}>;

const MapsContainer: FC<MapsContainerProps> = ({ isLoading, isDisabled, error, children }) => {
  const i18n = useI18n();

  return (
    <div className={styles.gmapsContainer}>
      {(error || isDisabled || isLoading) && (
        <div className={styles.gmapsOverlay}>
          {isLoading && <div className={styles.spinner}></div>}
          {error && <ErrorText text={i18n.translation.common.error} />}
        </div>
      )}
      {!isLoading && !error && children}
    </div>
  );
};

export default MapsContainer;
